import React, { Component } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Avatar, DefaultModal, Header, Page, PageContent, SidebarNav } from '../fgs';
import nav from '../_nav';
import Logo from '../assets/images/fgs-logo.png';
import routes from '../views';
import handleKeyAccessibility, { handleClickAccessibility } from '../fgs/helpers/handleTabAccessibility';
import RequestContext, { setAuthToken } from "../fgs/context/RequestContext";

import { getInitialData } from "../services/api";


const MOBILE_SIZE = 992;
const FIRST_LETTER = 0;
const FIRST_NAME = 0;
const SECOND_NAME = 1;

export default class DashboardLayout extends Component {
  static contextType = RequestContext;

  constructor(props) {
    super(props);
    this.state = {
      sidebarCollapsed: false,
      isMobile: window.innerWidth <= MOBILE_SIZE
    };
  }

  setLoggedUser = (data) => {
    this.context.setLoggedUser({ ...data.attributes });
  }

  handleResize = () => {
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ sidebarCollapsed: false, isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  componentDidUpdate(prev) {
    if (this.state.isMobile && prev.location.pathname !== this.props.location.pathname) {
      this.toggleSideCollapse();
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('keydown', handleKeyAccessibility);
    document.addEventListener('click', handleClickAccessibility);
    getInitialData().then(response => {
      if (response && response.data) {
        this.setLoggedUser(response.data.data);
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  toggleSideCollapse = () => {
    this.setState(prevState => ({ sidebarCollapsed: !prevState.sidebarCollapsed }));
  };

  render() {
    const { sidebarCollapsed } = this.state;
    const sidebarCollapsedClass = sidebarCollapsed ? 'side-menu-collapsed' : '';
    return (
      <React.Fragment>
        <div className={`app ${sidebarCollapsedClass}`}>
          <div className="app-body">
            <SidebarNav
              nav={nav}
              logo={Logo}
              isSidebarCollapsed={sidebarCollapsed}
              toggleSidebar={this.toggleSideCollapse}
              {...this.props}
            />
            <Page>
              <Header
                toggleSidebar={this.toggleSideCollapse}
                isSidebarCollapsed={sidebarCollapsed}
                routes={routes}
                {...this.props}
              >
                <HeaderNav loggedUser={this.context.loggedUser} />
              </Header>
              <PageContent>
                <DefaultModal />
                <Switch>
                  {
                    routes
                      .filter(route => this.context
                        .loggedUser
                        ?.permissions
                        ?.find(permission => permission.page === route.componentName))
                      .map((page, key) => (
                        <Route path={page.path} component={page.component} key={key} />
                      ))
                  }
                </Switch>
              </PageContent>
            </Page>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function HeaderNav(props) {
  const { loggedUser } = props;
  const history = useHistory();

  const logout = () => {
    setAuthToken(null);
    location.href = "/signin";
  };

  const getInitials = () => {
    if (loggedUser && loggedUser.name) {
      const splittedName = loggedUser.name.split(" ");
      const first = splittedName[FIRST_NAME][FIRST_LETTER].toUpperCase();
      const second = splittedName[SECOND_NAME] ? splittedName[SECOND_NAME][FIRST_LETTER].toUpperCase() : null;

      return first && second ? `${first}${second}` : first;
    }

    return "";
  };

  const onMyProfileClick = () => {
    history.push(`/dashboard/users/${loggedUser.id}/profile/`);
  };

  const initials = getInitials();

  return (
    <React.Fragment>
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav>
          <Avatar size="small" initials={initials} />
        </DropdownToggle>
        <DropdownMenu right>
          {initials ? <DropdownItem header>{loggedUser.name}</DropdownItem> : null}
          <DropdownItem divider />
          <DropdownItem onClick={onMyProfileClick}>Meu Perfil</DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={logout}>Sair</DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </React.Fragment>
  );
}
